var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66646 14.5C8.47709 14.5 8.29282 14.4454 8.14133 14.3444L4.64047 11.9722C4.53338 11.899 4.44683 11.8047 4.38761 11.6967C4.32839 11.5888 4.29811 11.4701 4.29913 11.35V8.80667L0.0980962 1.63556C0.0289098 1.51688 -0.0046936 1.38436 0.000527608 1.25078C0.00574882 1.1172 0.0496183 0.987069 0.127904 0.872942C0.20619 0.758815 0.316251 0.664542 0.447469 0.599218C0.578687 0.533894 0.726634 0.499723 0.877038 0.500002H13.1301C13.2819 0.500025 13.4312 0.535175 13.5632 0.601996C13.6952 0.668817 13.8053 0.765008 13.8827 0.881113C13.9596 0.99935 14 1.13347 14 1.27C14 1.40653 13.9596 1.54065 13.8827 1.65889L9.50666 8.82222V13.7222C9.5078 13.8672 9.46333 14.0095 9.37828 14.1332C9.29322 14.2569 9.17096 14.357 9.0253 14.4222C8.91327 14.4705 8.79093 14.4971 8.66646 14.5Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.622605408ffd9c083d437d0273af3c4c.svg";
export { ForwardRef as ReactComponent };